import type { FPlusContextScopeOutput } from '@festina/configuration-general-types/configuration'
import { notEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { Tabs } from '@festina-life/ui/structure'
import { useMemo, useState } from 'react'

import { FPlusFunctionScopeList } from './FPlusFunctionScopeList'
import { FPlusVariableScopeList } from './FPlusVariableScopeList'

type FPlusContextItemProps = {
  context: FPlusContextScopeOutput
}

export const FPlusContextItem = ({ context }: FPlusContextItemProps) => {
  const translate = useTranslate()
  const [tabIndex, setTabIndex] = useState(0)

  const FPlusScopeTabItems = useMemo(() => {
    const variables = context.variables?.length
      ? translate('templateViewer.sidebar.scopePopover.variables')
      : undefined
    const functions = context.functions?.length
      ? translate('templateViewer.sidebar.scopePopover.functions')
      : undefined

    return [variables, functions].filter(notEmpty)
  }, [translate, context])

  return (
    <Tabs
      items={FPlusScopeTabItems}
      selectedIndex={tabIndex}
      onChange={setTabIndex}
      tabItemsClassName="px-2 dark:border-gray-500 selected:border-hidden border-hidden"
      panelClassName="overflow-hidden h-full"
    >
      {!!context.variables?.length && (
        <FPlusVariableScopeList
          variables={context.variables?.filter(notEmpty)}
        />
      )}
      {!!context.functions?.length && (
        <FPlusFunctionScopeList
          functions={context.functions?.filter(notEmpty)}
        />
      )}
    </Tabs>
  )
}
